var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadingCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1591 0H2.06814C0.95564 0 0.0555241 0.9 0.0555241 2L0.0454102 18C0.0454102 19.1 0.945526 20 2.05803 20H14.2045C15.3171 20 16.2273 19.1 16.2273 18V6L10.1591 0ZM14.2045 18H2.06814V2H9.14771V7H14.2045V18ZM4.09088 13.01L5.51691 14.42L7.12498 12.84V17H9.14771V12.84L10.7558 14.43L12.1818 13.01L8.14646 9L4.09088 13.01Z",
    fill: "#1F6BEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingCardIcon);
export default __webpack_public_path__ + "static/media/UploadingCardIcon.e206ab84.svg";
export { ForwardRef as ReactComponent };